import Vue from 'vue'
import Vuex from 'vuex'
// vuex-persistedstateをsimplestorage使うための記述
// import createPersistedState from 'vuex-persistedstate'
import createPersistedState from '@/service'

// modules
import auth from '@/store/modules/auth'
import accountCreate from '@/store/modules/accountCreate'
import accountEdit from '@/store/modules/accountEdit'
import mailChange from '@/store/modules/mailChange'
import passwordForgot from '@/store/modules/passwordForgot'
import prefectures from '@/store/modules/prefectures'

Vue.use(Vuex)

const modules = {
  auth,
  history,
  accountCreate,
  accountEdit,
  mailChange,
  passwordForgot,
  prefectures
}

const initialState = {
  isLoading: false,
  backUrl: null,
  redirectUrl: null
}

export const state = {...initialState}

const getters = {
  isLoading: state => state.isLoading,
  backUrl: state => state.backUrl,
  redirectUrl: state => state.redirectUrl
}

const mutations = {
  loadingAction (state, payload) {
    state.isLoading = payload
  },
  setBackUrl (state, val) {
    state.backUrl = val
  },
  setRedirectUrl (state, val) {
    state.redirectUrl = val
  }
}

const actions = {
  setLoading ({commit}, data) {
    commit('loadingAction', data)
  },
  setBackUrl ({commit}, val) {
    commit('setBackUrl', val)
  },
  setRedirectUrl ({commit}, val) {
    commit('setRedirectUrl', val)
  }
}

export default new Vuex.Store({
  modules,
  state,
  actions,
  mutations,
  getters,
  plugins: [createPersistedState(
    {
      key: 'astro-app',
      paths: [
        'auth',
        'appSetting',
        'prefectures'
      ]
    }
  )]
})



// WEBPACK FOOTER //
// ./src/store/index.js